import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-header-sna',
  templateUrl: './header-sna.component.html',
  styleUrls: ['../header-top/header-top.component.scss', './header-sna.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderSnaComponent {
  constructor() {}
}
